<section
  [attr.id]="sectionId() || null"
  [class]="'s__hero-section s__bg-dark' + (variant() === 'image' ? ' s__hero-section--image' : '') + (cssClass() ? ' ' + cssClass() : '')"
>
  @if (variant() === 'image' && backgroundImage()) {
    <img
      class="s__hero-section__image"
      [ngSrc]="backgroundImage()"
      [width]="backgroundImageWidth() || 1920"
      [height]="backgroundImageHeight() || 600"
      priority
      [alt]="backgroundImageAlt() || ''"
      [sizes]="imageSizes()"
      [ngSrcset]="imageSrcset()"
    />
  }
  @if (variant() === 'image') {
    <div class="s__hero-section__overlay"></div>
  }

  <div class="s__hero-section__inner s__container">
    @if (overlineElement() === 'h1') {
      <h1 class="s__overline">{{ overline() }}</h1>
    } @else if (overlineElement() === 'p') {
      <p class="s__overline">{{ overline() }}</p>
    }

    @if (headingElement() === 'h1') {
      <h1 class="s__hero-section__heading">{{ heading() }}</h1>
    } @else if (headingElement() === 'h2') {
      <h2 class="s__hero-section__heading">{{ heading() }}</h2>
    }

    @if (subtitle()) {
      <p class="s__hero-section__subtitle">{{ subtitle() }}</p>
    }

    @if (lead()) {
      <p class="s__hero-section__lead">{{ lead() }}</p>
    }

    @if (resolvedActions().length > 0) {
      <div class="s__hero-section__actions">
        @for (action of resolvedActions(); track action.label) {
          <a [attr.href]="action.href" [class]="'s__btn s__btn--' + action.variant">{{ action.label }}</a>
        }
      </div>
    }

    @if (stats().length > 0) {
      <div class="s__hero-section__stats">
        <ds-stats-block [stats]="stats()" />
      </div>
    }
  </div>
</section>
